<template>
	<header class="nav-header">
		<div class="nav-logo">
			<img src="../assets/logo.png" alt="vtimes" class="logo-image" />
		</div>

		<!-- 移动端汉堡菜单按钮 -->
		<div class="menu-toggle" @click="toggleMobileMenu">
			<div class="bar"></div>
			<div class="bar"></div>
			<div class="bar"></div>
		</div>

		<!-- 桌面端导航 -->
		<nav class="main-nav" :class="{ 'mobile-hidden': !isMobileMenuOpen }">
			<ul class="nav-list">
				<li class="nav-item" v-for="(item, index) in navItems" :key="index" @click="closeMobileMenu">
					<router-link :to="{ name: item.routeName }" class="nav-link" active-class="active" exact>
						{{ $t(`nav.${item.key}`) }}
					</router-link>
				</li>
			</ul>
		</nav>

		<div class="language-selector" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
			<i class="fas fa-globe"></i>
			<span>{{ $t('language') }}</span>
			<i class="fas fa-chevron-down chevron-down" :class="{ rotate: showDropdown }"></i>
			<div class="language-dropdown" v-show="showDropdown">
				<a href="#" class="language-option" @click.prevent="changeLanguage('zh-CN')">简体中文</a>
				<a href="#" class="language-option" @click.prevent="changeLanguage('en')">English</a>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: 'NavHeader',
	data() {
		return {
			showDropdown: false,
			isMobileMenuOpen: false,
			navItems: [
				{ key: 'home', routeName: 'Home' },
				{ key: 'about', routeName: 'About' },
				{ key: 'products', routeName: 'Products' },
				{ key: 'join', routeName: 'Join' },
				// { key: 'support', routeName: 'Support' },
				{ key: 'news', routeName: 'News' },
				{ key: 'download', routeName: 'Download' },
				{ key: 'after', routeName: 'After' }
			]
		};
	},
	methods: {
		changeLanguage(lang) {
			this.$i18n.locale = lang;
			this.showDropdown = false;
		},
		toggleMobileMenu() {
			this.isMobileMenuOpen = !this.isMobileMenuOpen;
		},
		closeMobileMenu() {
			this.isMobileMenuOpen = false; 
		}
	}
};
</script>

<style scoped>
.nav-header {
	display: flex;
	align-items: center;
	width: 100%;
	height: 65px;
	background-color: #ffffff;
	padding: 0 20px;
	position: relative;
}

.nav-logo {
	width: 120px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: auto;
}

.logo-image {
	max-width: 100%;
	max-height: 100%;
	width: auto;
	height: auto;
	object-fit: contain;
}
/* 移动端汉堡菜单按钮 */
.menu-toggle {
	display: none;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	cursor: pointer;
	margin-right: 15px;
}

.menu-toggle .bar {
	width: 25px;
	height: 3px;
	background-color: #333;
	margin: 3px 0;
	transition: all 0.3s ease;
}

/* 桌面端导航 */
.main-nav {
	display: flex;
	justify-content: center;
	flex: 1;
	transition: all 0.3s ease;
}

.nav-list {
	display: flex;
	list-style: none;
	margin: 0;
	padding: 0;
}

.nav-item {
	margin: 0 15px;
}
@media (max-width: 768px) {
	.menu-toggle {
		display: flex;
	}

	.main-nav {
		position: absolute;
		top: 80px;
		left: 0;
		width: 100%;
		background: white;
		flex-direction: column;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		padding: 20px 0;
		display: none;
	}

	.main-nav.mobile-hidden {
		display: none;
	}

	.main-nav:not(.mobile-hidden) {
		display: flex;
	}

	.nav-list {
		flex-direction: column;
		align-items: center;
	}

	.nav-item {
		margin: 10px 0;
		width: 100%;
		text-align: center;
	}

	.language-selector {
		margin-right: 15px;
		position: static; /* 重置定位 */
	}

	.language-dropdown {
		right: 15px; /* 调整下拉菜单位置 */
	}
}

.nav-link {
	text-decoration: none;
	color: #333333;
	font-size: 18px;
	font-weight: 500;
	padding: 8px 0;
	display: block;
	position: relative;
}

.nav-link.active {
	color: #30b4e9;
}

.language-selector {
	display: flex;
	align-items: center;
	color: #666666;
	font-size: 16px;
	cursor: pointer;
	position: relative;
	margin-right: 35px;
}

.language-selector i.fa-globe {
	margin-right: 8px;
	font-size: 16px;
}

.language-dropdown {
	position: absolute;
	top: 100%;
	right: 0;
	background: white;
	border-radius: 4px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	min-width: 180px;
	padding: 8px 0;
	opacity: 0;
	visibility: hidden;
	transform: translateY(10px);
	transition: all 0.25s ease;
	z-index: 1000;
}

.language-selector:hover .language-dropdown {
	opacity: 1;
	visibility: visible;
	transform: translateY(0);
}

.language-option {
	padding: 8px 16px;
	color: #3498db;
	font-size: 16px;
	display: block;
	text-decoration: none;
}

.language-option:hover {
	background: #f8f9fa;
	color: #2980b9;
}

.chevron-down {
	margin-left: 6px;
	font-size: 13px;
	transition: transform 0.2s;
}

.rotate {
	transform: rotate(180deg);
}

/* 点击效果 - 添加轻微缩放动画 */
.nav-item {
	transition: transform 0.2s ease;
}

.nav-item:active {
	transform: scale(0.95);
}

.nav-link:active {
	color: #1a5276;
}
</style>
